import React from 'react'
import moment from 'moment'
import { IInventoryLog } from '@getgreenline/inventory/build/models/inventoryLog'

interface Props {
  modify: (log: IInventoryLog) => void
  log: IInventoryLog
  canEdit: boolean
}

export function Row(props: Props) {
  const { log } = props

  return (
    <>
      <li className='list-group-item' key={log.id}>
        <div className='d-flex outline-light'>
          <div className='mr-2' style={{ width: 150 }}>
            <small className='text-muted'>Date</small>
            <div>{moment(log.createDate).format('MMM DD, YYYY h:mm A')}</div>
          </div>
          <div className='mr-2' style={{ width: 150 }}>
            <small className='text-muted'>Location</small>
            <div>{log.entityName}</div>
          </div>
          <div className='mr-2' style={{ width: 150 }}>
            <small className='text-muted'>Employee</small>
            <div style={{ wordWrap: 'break-word' }}>{log.userName}</div>
          </div>
          <div className='mr-2' style={{ flexGrow: 1 }}>
            <small className='text-muted'>Notes</small>
            <div>{log.note || '-'}</div>
          </div>
          <div className='text-right mr-2'>
            <small className='text-muted'>Start</small>
            <div>{log.previousValue}</div>
          </div>
          <div className='text-right mr-2'>
            <small className='text-muted'>End</small>
            <div>{log.newValue}</div>
          </div>
          <div className='text-right mr-4'>
            <small className='text-muted'>Change</small>
            <div>
              <b>{log.updateValue > 0 ? `+${log.updateValue}` : log.updateValue}</b>
            </div>
          </div>
          <div className='text-right mr-4'>
            <small className='text-muted'>Type</small>
            <div>{log.type}</div>
          </div>
          <div>
            <button
              className='btn btn-primary btn-sm mt-2'
              disabled={!props.canEdit}
              onClick={() => props.modify && props.modify(log)}
            >
              Modify
            </button>
          </div>
        </div>
      </li>
    </>
  )
}
